import type { GetMissionsParams } from '../types/missions.types';

/** Shared root of every missions query key — invalidate this prefix to refetch all lists + detail. */
export const MISSIONS_QUERY_KEY_PREFIX = 'missions';

export const MissionsQueryKeys = {
  /** Paginated missions list, keyed by status/offset/limit. */
  MISSIONS: (params?: GetMissionsParams) => [MISSIONS_QUERY_KEY_PREFIX, params] as const,
  /** Single mission detail (incl. rewards), keyed by assignment id. */
  MISSION_DETAIL: (assignmentId: string) =>
    [MISSIONS_QUERY_KEY_PREFIX, 'detail', assignmentId] as const,
};
